import React from 'react';
import { Card, CardContent } from './ui/card';
import { Star, Quote } from 'lucide-react';

const testimonials = [
  {
    name: 'Fatima',
    relation: 'Maman de Mouhab, 4 ans',
    content: "Psychomotricienne très professionnelle, douce et à l’écoute, Mon enfant est suivi par elle depuis quatre mois et elle a su le mettre rapidement en confiance avec des séances bien adaptées. Je recommande vivement.",
    rating: 5,
  },
  {
    name: 'Ibtissame',
    relation: 'Maman de Ahmed, 6 ans',
    content: "Dr Hind a été la raison pour laquelle mon fils a pu me comprendre et pour laquelle j’ai pu le comprendre à mon tour. Je n’aurais jamais imaginé qu’il se sentirait aussi à l’aise et apaisé en entrant dans son cabinet, au point qu’il a commencé à frapper à sa porte pour y entrer rapidement. Un immense merci pour sa patience, sa compréhension de la situation complexe de mon fils, ainsi que pour l’aide qu’elle nous a apportée à tous les deux, et pour l’avoir aidé à faire comprendre au monde qui il est.",
    rating: 5,
  },
  {
    name: 'Firdaouss',
    relation: 'Maman de Islam, 3 ans',
    content: "Je suis très satisfaite du travail de Dr Hind avec mon fils. C’est une professionnelle compétente, humaine, à l’écoute et très coopérative. Elle fait preuve de patience et de bienveillance. Grâce à son accompagnement, mon fils a réalisé de réels progrès. Je la recommande vivement.",
    rating: 5,
  },
];

export const Testimonials = () => {
  return (
    <section id="temoignages" className="section-padding bg-card relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/4 -left-20 w-60 h-60 bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 -right-20 w-80 h-80 bg-accent/5 rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto container-padding">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-medium mb-6">
            <Star className="w-4 h-4" />
            <span>Témoignages</span>
          </div>

          <h2 className="font-display text-3xl sm:text-4xl font-semibold text-foreground mb-6">
            Ce que disent les{' '}
            <span className="text-gradient">familles</span>
          </h2>

          <p className="text-lg text-muted-foreground">
            Le retour des familles que j'accompagne est ma plus belle récompense. Voici quelques témoignages de parents.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {testimonials.map((testimonial, index) => (
            <Card
              key={index}
              className="border-0 shadow-soft hover:shadow-card bg-background transition-all duration-300 group"
            >
              <CardContent className="p-6 lg:p-8 flex flex-col h-full">
                {/* Quote Icon */}
                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors duration-300">
                  <Quote className="w-5 h-5 text-primary" />
                </div>

                {/* Rating */}
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star
                      key={i}
                      className="w-4 h-4 text-warning fill-warning"
                    />
                  ))}
                </div>

                {/* Content */}
                <p className="text-muted-foreground leading-relaxed mb-6 flex-1">
                  &ldquo;{testimonial.content}&rdquo;
                </p>

                {/* Author */}
                <div className="pt-4 border-t border-border">
                  <p className="font-semibold text-foreground">
                    {testimonial.name}
                  </p>
                  <p className="text-sm text-muted-foreground">
                    {testimonial.relation}
                  </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Note */}
        <p className="text-center text-sm text-muted-foreground mt-10">
          <em>* Témoignages anonymisés par souci de confidentialité</em>
        </p>
      </div>
    </section>
  );
};

export default Testimonials;